export const SET_VALUE = 'SET_VALUE';
export const BLUR_FIELD = 'BLUR_FIELD';
export const RESET = 'RESET';
export const SET_IS_VALID = 'SET_IS_VALID';

export const formReducer = (state, action) => {
  let field;
  switch (action.type) {
    case SET_VALUE:
      field = {
        value: action.value,
        isValid: action.isValid
      };
      return {
        ...state,
        [action.name]: field
      };
    case BLUR_FIELD:
      field = state[action.name];
      if (!field) return state;

      field.blurred = true;
      return {
        ...state,
        [action.name]: field
      };
    case RESET:
      return {};
    default:
      return state;
  }
};

export const setValue = (name, value, isValid) => ({
  type: SET_VALUE,
  name,
  value,
  isValid
});

export const onBlur = (name) => ({
  type: BLUR_FIELD,
  name
});

export const reset = () => ({
  type: RESET
});

export const setIsValid = (name, isValid) => ({
  type: SET_IS_VALID,
  name,
  isValid
});
